// @flow

import React from 'react';
import Translate from 'client/components/translate';
import Checkmark from 'client/components/checkmark';
import type { ToggleItemType } from 'types/toggleItemType.flow';
import SelectionListItem from './selectionListItem';

type Props = {
  item: ToggleItemType,
  checked: boolean,
  clickHandler?: Function,
  className?: string,
};

export default class ToggleItem extends React.PureComponent<Props> {
  static defaultProps = {
    clickHandler: () => {},
    className: '',
  };

  render() {
    const { item, clickHandler, checked, className } = this.props;

    return (
      <SelectionListItem
        checked={checked}
        className={className}
        clickHandler={e => clickHandler(e)}
        imageUrl={item.imageUrl}
        leftContent={
          <div className="content">
            <div className="title grey-2-color">
              {item.titleKey ? <Translate path={item.titleKey} /> : item.title}
            </div>
            {(item.subtitle || item.subtitleKey) && (
              <div className="subtitle">
                {item.subtitleKey ? <Translate path={item.subtitleKey} /> : item.subtitle}
              </div>
            )}
          </div>
        }
        rightContent={<Checkmark checked={checked} />} />
    );
  }
}
